import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  linkDayforceShift,
  type LinkDayforceShiftRequest,
} from 'api/admin/dayforce/linkDayforceShift'
import { dayforceKeys } from './keys'

export const useLinkDayforceShiftMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: LinkDayforceShiftRequest) =>
      linkDayforceShift(request),
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: dayforceKeys.all,
      }),
  })
}
